export default __webpack_public_path__ + "static/media/g2021-8.4de23293.jpeg";